import $ from 'jquery';
export default class ShowElementOnClick {
    static init() {
        $('.js__show-on-click').each((i, element) => {
            const $element = $(element);
            const $target = $($element.data('target'));
            $target.on('click', () => {
                $element.removeClass('d-none');
            });
        });
    }
}
